/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EdiInvoiceSendTiming {
  AtBooking = "at_booking",
  AfterFirstTracking = "after_first_tracking",
}

export function instanceOfEdiInvoiceSendTiming(value: any): boolean {
  for (const key in EdiInvoiceSendTiming) {
    if (Object.prototype.hasOwnProperty.call(EdiInvoiceSendTiming, key)) {
      if (
        EdiInvoiceSendTiming[key as keyof typeof EdiInvoiceSendTiming] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EdiInvoiceSendTimingFromJSON(json: any): EdiInvoiceSendTiming {
  return EdiInvoiceSendTimingFromJSONTyped(json, false);
}

export function EdiInvoiceSendTimingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EdiInvoiceSendTiming {
  return json as EdiInvoiceSendTiming;
}

export function EdiInvoiceSendTimingToJSON(
  value?: EdiInvoiceSendTiming | null,
): any {
  return value as any;
}

export function EdiInvoiceSendTimingToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EdiInvoiceSendTiming {
  return value as EdiInvoiceSendTiming;
}
